import styled from 'styled-components';

import { Summary } from 'models/flexible/Summary';
import type { AdminSummaryShowFields } from 'services/api/fields';
import { colors } from 'styles/theme/colors';

export default function SourceList({
  summary,
}: {
  summary: Summary<AdminSummaryShowFields<'attachments' | 'aiArtifact'>>;
}) {
  if (!summary.attachments?.length) {
    return <EmptyText>No sources available</EmptyText>;
  }

  const artifactSources = summary.aiArtifact?.data?.sources;
  const sources = artifactSources || summary.attachments;

  return (
    <StyledList>
      {sources.map((source: any, idx: number) => {
        const filename =
          source.filename ||
          source.blob?.filename ||
          summary.attachments?.find((a: any) => a.id === source.attachmentId)?.filename ||
          'No filename';
        return (
          <li key={source.id ?? source.attachmentId ?? idx}>
            <SourceName>{filename}</SourceName>
          </li>
        );
      })}
    </StyledList>
  );
}

const EmptyText = styled.p`
  color: ${colors.black50};
  font-style: italic;
`;

const StyledList = styled.ul`
  list-style-type: disc;
  margin-left: 20px;
  margin-top: 8px;
`;

const SourceName = styled.span`
  text-decoration: none;
  width: 100%;
  word-break: break-word;
`;
